import { database } from '../firebase';
import { ref, set, get, update } from 'firebase/database';

// Save/update user profile without overwriting other data
export const saveUserProfile = async (userId, userProfile) => {
    try {
        const updates = {
            [`users/${userId}/profile/name`]: userProfile.name,
            [`users/${userId}/profile/email`]: userProfile.email,
            [`users/${userId}/profile/picture`]: userProfile.picture
        };
        await update(ref(database), updates);
        console.log('✅ User profile saved');
        return true;
    } catch (error) {
        console.error('Error saving user profile:', error);
        return false;
    }
};

// Save user's canvas URL
export const saveUserCanvasUrl = async (userId, canvasUrl) => {
    try {
        const dataRef = ref(database, `users/${userId}/canvasUrl`);
        await set(dataRef, canvasUrl);
        console.log('✅ Canvas URL saved');
        return true;
    } catch (error) {
        console.error('Error saving canvas URL:', error);
        return false;
    }
};

// Get user's canvas URL
export const getUserCanvasUrl = async (userId) => {
    try {
        const dataRef = ref(database, `users/${userId}/canvasUrl`);
        const snapshot = await get(dataRef);
        if (snapshot.exists()) {
            return snapshot.val();
        }
        return null;
    } catch (error) {
        console.error('Error getting canvas URL:', error);
        return null;
    }
};

export const saveCanvasCourses = async (userId, courses) => {
    const dataRef = ref(database, `users/${userId}/canvasCourses`);
    await set(dataRef, courses);
};

export const loadCanvasCourses = async (userId) => {
    const dataRef = ref(database, `users/${userId}/canvasCourses`);
    const snapshot = await get(dataRef);
    return snapshot.exists() ? snapshot.val() : [];
};

// Get user profile
export const getUserProfile = async (userId) => {
    try {
        const dataRef = ref(database, `users/${userId}/profile`);
        const snapshot = await get(dataRef);
        if (snapshot.exists()) {
            return snapshot.val();
        }
        return null;
    } catch (error) {
        console.error('Error getting user profile:', error);
        return null;
    }
};